export const calculateSpeedProfileAddition = (designClass, radius) => {
    if(!designClass || !radius) return null;

    if(!designClass.speedProfileAddition) return 0;

    const SPAMax = 5;

    const SPA1 = 1/Math.abs(radius);
    const SPA2 = 1/designClass.minHorizontalRadius;
    const SPA3 = 1/designClass.maxHorizontalRadius;
    
    let SPA = SPAMax * (SPA1 - SPA2)/(SPA3 - SPA2);
    SPA = Math.min(SPA, SPAMax);
    SPA = Math.max(SPA, 0);

    return SPA;
}